"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FileUpload = FileUpload;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

// eslint-disable-next-line valid-jsdoc

/**
 * FileUpload uses FormData to batch upload a list of input files.
 *
 * @param {FileList} files - This is the FileList instance from FileInput.
 * @param {string} action - String URI of the API call.
 * @param {function} onDone - Callback when the http request is completed.
 *    This doesn't mean that the files have uploaded successfully.
 *    For that you should consult with your version of the API response(xhr.status).
 * @param {function} onProgress - Callback when upload is in progress.
 *    onProgress(ProgressEvent)
 *    https://developer.mozilla.org/en-US/docs/Web/API/ProgressEvent
 * @param {function} onError - Callback when upload encounter networking error.
 *    NOTE: this is non http error.  To handle http error use onDone and check the xhr.status
 * @param {function} onAbort - Callback when upload is aborted.
 * @param {function} onStart - Callback before the XHR.send() to uploading the files.
 *    This is a good place to customize the XHR request(adding header or monitor other events etc..)
 *    onStart(XMLHttpRequest)
 *    https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/Using_XMLHttpRequest
 *
 * @return {XMLHttpRequest}
 */
function FileUpload(_ref) {
  var files = _ref.files,
      action = _ref.action,
      _ref$onDone = _ref.onDone,
      onDone = _ref$onDone === void 0 ? function () {
    return 0;
  } : _ref$onDone,
      _ref$onProgress = _ref.onProgress,
      onProgress = _ref$onProgress === void 0 ? function () {
    return 0;
  } : _ref$onProgress,
      _ref$onError = _ref.onError,
      onError = _ref$onError === void 0 ? function () {
    return 0;
  } : _ref$onError,
      _ref$onAbort = _ref.onAbort,
      onAbort = _ref$onAbort === void 0 ? function () {
    return 0;
  } : _ref$onAbort,
      _ref$onStart = _ref.onStart,
      onStart = _ref$onStart === void 0 ? function () {
    return 0;
  } : _ref$onStart;
  var xhr = new XMLHttpRequest();
  xhr.addEventListener('load', onDone);
  xhr.upload.addEventListener('progress', onProgress);
  xhr.upload.addEventListener('error', onError);
  xhr.upload.addEventListener('abort', onAbort);
  xhr.open('post', action);
  onStart(xhr);
  var formData = new FormData();

  for (var i = 0; i < files.length; i++) {
    var file = files[i];
    formData.append('file', file);
  }

  xhr.send(formData);
  return xhr;
}
/**
 * This component provided file upload function to a component in props.component.
 */


var FileUploadProvider =
/*#__PURE__*/
function (_React$Component) {
  _inherits(FileUploadProvider, _React$Component);

  /**
   * This is really an HOC function but implemented as a React component class.
   * The decision to do it this way is because we can document this better
   * with the current limitation of the styleguide(can't provide doc for function).
   */
  function FileUploadProvider(props) {
    var _this;

    _classCallCheck(this, FileUploadProvider);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FileUploadProvider).call(this, props));

    _this.handleUploadDone = function () {
      var onDone = _this.props.onDone;

      _this.setState({
        isInProgress: false
      });

      if (onDone) {
        onDone();
      }
    };

    _this.handleUploadAbort = function () {
      var onAbort = _this.props.onAbort;

      _this.setState({
        isInProgress: false
      });

      if (onAbort) {
        onAbort();
      }
    };

    _this.handleOnClick = function (e) {
      var onClick = _this.props.componentProps.onClick;

      if (_this.state.isInProgress) {
        return;
      }

      if (onClick) {
        onClick(e);
      }

      _this._uploadData();
    };

    _this.state = {
      isInProgress: false
    };
    _this.xhr = null;
    _this.summary = {};
    return _this;
  }

  _createClass(FileUploadProvider, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!this.xhr) {
        return;
      }

      var _this$props = this.props,
          abortOnUnMount = _this$props.abortOnUnMount,
          onDone = _this$props.onDone,
          onAbort = _this$props.onAbort;
      this.xhr.removeEventListener('load', this.handleUploadDone);
      this.xhr.removeEventListener('abort', this.handleUploadAbort);

      if (abortOnUnMount) {
        this.xhr.abort();
      } else {
        // Since the application doesn't want to abort the xhr request.
        // We need to assume that the application still want to listen
        // to the done/abort event.
        if (onDone) {
          this.xhr.addEventListener('load', onDone);
        }

        if (onAbort) {
          this.xhr.addEventListener('abort', onAbort);
        }
      }
    }
    /**
     * Handle to done event of the xhr uploading request.
     */

  }, {
    key: "_uploadData",

    /**
     * Calling the FileUpload util to initiate the upload xhr request.
     * @private
     */
    value: function _uploadData() {
      var _this$props2 = this.props,
          files = _this$props2.files,
          action = _this$props2.action,
          onProgress = _this$props2.onProgress,
          onError = _this$props2.onError,
          onStart = _this$props2.onStart;
      this.xhr = FileUpload({
        files: files,
        action: action,
        onDone: this.handleUploadDone,
        onProgress: onProgress,
        onError: onError,
        onAbort: this.handleUploadAbort,
        onStart: onStart
      });
      this.setState({
        isInProgress: true
      });
    }
    /**
     * Handle the wrapping component click event.
     * @param {ClickEvent} e - this is the click event.
     */

  }, {
    key: "render",
    value: function render() {
      // eslint-disable-next-line no-unused-vars
      var _this$props3 = this.props,
          files = _this$props3.files,
          action = _this$props3.action,
          abortOnUnMount = _this$props3.abortOnUnMount,
          onDone = _this$props3.onDone,
          onStart = _this$props3.onStart,
          onError = _this$props3.onError,
          onAbort = _this$props3.onAbort,
          onProgress = _this$props3.onProgress,
          Component = _this$props3.component,
          componentProps = _this$props3.componentProps; // eslint-disable-next-line no-unused-vars

      var onClick = componentProps.onClick,
          _componentProps = _objectWithoutProperties(componentProps, ["onClick"]);

      return _react.default.createElement(Component, _extends({
        onClick: this.handleOnClick,
        disabled: this.state.isInProgress
      }, _componentProps));
    }
  }]);

  return FileUploadProvider;
}(_react.default.Component);

exports.default = FileUploadProvider;
FileUploadProvider.FileUpload = FileUpload;
FileUploadProvider.defaultProps = {
  files: [],
  abortOnUnMount: true,
  componentProps: {}
};
FileUploadProvider.propTypes = {
  /**
   * This is the FileList object or array of File object.
   */
  files: _propTypes.default.array.isRequired,

  /**
   * String URI of the API call.
   */
  action: _propTypes.default.string.isRequired,

  /**
   * Callback before the XHR.send() to uploading the files.
   * This is a good place to customize the XHR request(adding header or monitor other events etc..)<br>
   * onStart(xhr)<br>
   * @param {XMLHttpRequest} xhr - [See this](https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest)
   */
  onStart: _propTypes.default.func,

  /**
   * Callback when the http request is completed.
   * This doesn't necessary mean that the files have uploaded successfully.
   * For success and failure one should consult with API response(xhr.status).
   */
  onDone: _propTypes.default.func,

  /**
   * Callback when upload is in progress.<br>
   * onProgress(progressEvent)<br>
   * @param {ProgressEvent} progressEvent - [See this](https://developer.mozilla.org/en-US/docs/Web/API/ProgressEvent)
   */
  onProgress: _propTypes.default.func,

  /**
   * Callback when upload failed with non-http error.  For example network connection error.
   * Remember, if you didn't get onError it still doesn't mean that your files have been uploaded
   * successfully.  See onDone.
   */
  onError: _propTypes.default.func,

  /**
   * Callback when the upload is aborted.
   */
  onAbort: _propTypes.default.func,

  /**
   * Abort pending upload when component is unmounted.
   * In situation where you want to continue the
   * pending upload even when the component has been unmounted, set this
   * to false.
   */
  abortOnUnMount: _propTypes.default.bool,

  /**
   * The component to provide file upload.  For example Button
   */
  component: _propTypes.default.func.isRequired,

  /**
   * The props that will be pass to the component.
   */
  componentProps: _propTypes.default.object
};